// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-hover:hover {
  background-color: #bfbfbf;
  background-color: #ececec;
}
.filtros {
  background-color: rgb(220, 220, 220);
  padding: 10px;
  border-radius: 3px;
}
/* Reducir el tamaño de los elementos */
.dataTables_wrapper .dataTables_filter input {
  height: 30px;
  font-size: 14px;
}

.dataTables_wrapper .dataTables_length select {
  height: 30px;
  font-size: 14px;
}

.dataTables_wrapper .pagination .paginate_button {
  padding: 0.3rem 0.6rem;
  font-size: 14px;
}

/* issue board */
/* Personalización del colapso horizontal */
.collapse-horizontal {
  width: 100vw;
  max-width: 101%; /* Define el tamaño máximo cuando está expandido */
  overflow: hidden;
  transition: max-width 0.4s ease; /* Anima el ancho */
}
  
.collapse-horizontal:not(.show) {
  max-width: 0; /* Colapsa el ancho */
}
.h-110 {
  height: 110vh;
}  

/* Diseño para tabs */
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #ffffff;
  background-color: #d43c00;
  border-color: #d43c00 #d43c00 #d43c00;

  background-color: #bc0000;
  border-color: #bc0000 #bc0000 #bc0000;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link {
  /* color: #ffffff; */
  color: #d43c00;
  color: #bc0000;
  /* border-color: #d43c00 #d43c00 #d43c00; */
}
.nav-tabs {
  border-bottom: 1px solid #bc0000;
}

  /* Acordeón vertical en pantallas pequeñas */
@media (max-width: 991px) {
  .collapse-horizontal {
    width: 100%;
    max-height: 0;
    transition: max-height 0.4s ease; /* Animación de colapso vertical */
    overflow: hidden;
  }

  .collapse-horizontal.show {
    max-height: 100%; 
  }

  .collapse-horizontal:not(.show) {
    max-height: 0;
  }

  /* Flecha izquierda/derecha para pantallas grandes */
  /* .fa-chevron-up, .fa-chevron-down {
    display: none;
  } */
}

/* Flecha arriba/abajo para pantallas pequeñas */
/* @media (max-width: 767px) {
  .fa-chevron-left, .fa-chevron-right {
    display: none;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/constructor-guias/constructor-guias.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;AACpB;AACA,uCAAuC;AACvC;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA,gBAAgB;AAChB,2CAA2C;AAC3C;EACE,YAAY;EACZ,eAAe,EAAE,kDAAkD;EACnE,gBAAgB;EAChB,+BAA+B,EAAE,mBAAmB;AACtD;;AAEA;EACE,YAAY,EAAE,qBAAqB;AACrC;AACA;EACE,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,yBAAyB;EACzB,qCAAqC;;EAErC,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,gCAAgC;AAClC;;EAEE,4CAA4C;AAC9C;EACE;IACE,WAAW;IACX,aAAa;IACb,gCAAgC,EAAE,kCAAkC;IACpE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,oDAAoD;EACpD;;KAEG;AACL;;AAEA,gDAAgD;AAChD;;;;GAIG","sourcesContent":[".table-hover:hover {\n  background-color: #bfbfbf;\n  background-color: #ececec;\n}\n.filtros {\n  background-color: rgb(220, 220, 220);\n  padding: 10px;\n  border-radius: 3px;\n}\n/* Reducir el tamaño de los elementos */\n.dataTables_wrapper .dataTables_filter input {\n  height: 30px;\n  font-size: 14px;\n}\n\n.dataTables_wrapper .dataTables_length select {\n  height: 30px;\n  font-size: 14px;\n}\n\n.dataTables_wrapper .pagination .paginate_button {\n  padding: 0.3rem 0.6rem;\n  font-size: 14px;\n}\n\n/* issue board */\n/* Personalización del colapso horizontal */\n.collapse-horizontal {\n  width: 100vw;\n  max-width: 101%; /* Define el tamaño máximo cuando está expandido */\n  overflow: hidden;\n  transition: max-width 0.4s ease; /* Anima el ancho */\n}\n  \n.collapse-horizontal:not(.show) {\n  max-width: 0; /* Colapsa el ancho */\n}\n.h-110 {\n  height: 110vh;\n}  \n\n/* Diseño para tabs */\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\n  color: #ffffff;\n  background-color: #d43c00;\n  border-color: #d43c00 #d43c00 #d43c00;\n\n  background-color: #bc0000;\n  border-color: #bc0000 #bc0000 #bc0000;\n}\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link {\n  /* color: #ffffff; */\n  color: #d43c00;\n  color: #bc0000;\n  /* border-color: #d43c00 #d43c00 #d43c00; */\n}\n.nav-tabs {\n  border-bottom: 1px solid #bc0000;\n}\n\n  /* Acordeón vertical en pantallas pequeñas */\n@media (max-width: 991px) {\n  .collapse-horizontal {\n    width: 100%;\n    max-height: 0;\n    transition: max-height 0.4s ease; /* Animación de colapso vertical */\n    overflow: hidden;\n  }\n\n  .collapse-horizontal.show {\n    max-height: 100%; \n  }\n\n  .collapse-horizontal:not(.show) {\n    max-height: 0;\n  }\n\n  /* Flecha izquierda/derecha para pantallas grandes */\n  /* .fa-chevron-up, .fa-chevron-down {\n    display: none;\n  } */\n}\n\n/* Flecha arriba/abajo para pantallas pequeñas */\n/* @media (max-width: 767px) {\n  .fa-chevron-left, .fa-chevron-right {\n    display: none;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
